module.exports = __webpack_public_path__ + "unknown-device.11e8ebbae8b1016671155b10d6f0a803.png";